import React from "react";
import { Translation } from "react-i18next";

export const OnlineExamPageConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      title: <Translation>{(t) => t("navigation.main.exam_list")}</Translation>,
      path: "/exams",
      exact: true,
      component: React.lazy(() => import("./exam/exams/ExamsPage")),
    },
    {
      title: (
        <Translation>{(t) => t("navigation.main.submit_new_exam")}</Translation>
      ),
      path: "/exams/add-exam",
      exact: true,
      component: React.lazy(() => import("./exam/addExam/AddExamPage")),
    },
    {
      title: (
        <Translation>
          {(t) => t("navigation.main.question_management")}
        </Translation>
      ),
      path: "/exams/:id",
      exact: true,
      component: React.lazy(() => import("./exam/questions/ExamQuestionsPage")),
    },
    {
      title: <Translation>{(t) => t("navigation.main.edit_exam")}</Translation>,
      path: "/exams/add-exam/:id",
      exact: true,
      component: React.lazy(() => import("./exam/addExam/AddExamPage")),
    },
    {
      title: (
        <Translation>{(t) => t("navigation.main.exam_report")}</Translation>
      ),
      path: "/exams/exam-report/:id",
      exact: true,
      component: React.lazy(() => import("./exam/examReport/ExamReportPage")),
    },
    {
      title: (
        <Translation>
          {(t) => t("navigation.main.exam_student_report")}
        </Translation>
      ),
      path: "/exams/exam-student-report/:id",
      exact: true,
      component: React.lazy(() =>
        import("./exam/examStudentReport/ExamStudentReportPage")
      ),
    },
    {
      title: <Translation>{(t) => t("navigation.main.workbook")}</Translation>,
      path: "/exams/work-book/:examID/:studentID",
      exact: true,
      component: React.lazy(() => import("./exam/workBook/WorkBookPage")),
    },
    {
      path: "/exams/exam-student-report/:id/showAll",
      exact: true,
      component: React.lazy(() =>
        import("./exam/examStudentReport/ExamStudentsResultShowAll")
      ),
    },
    {
      title: (
        <Translation>{(t) => t("navigation.main.exam_bank_list")}</Translation>
      ),
      path: "/exam-bank",
      exact: true,
      component: React.lazy(() =>
        import("./examBank/ExamBankExams/ExamBankExamsPage")
      ),
    },
    {
      title: (
        <Translation>{(t) => t("navigation.main.edit_exam_bank")}</Translation>
      ),
      path: "/exam-bank/add-exam/:id",
      exact: true,
      component: React.lazy(() =>
        import("./examBank/AddExamBank/AddExamBankPage")
      ),
    },
    {
      title: (
        <Translation>
          {(t) => t("navigation.main.submit_new_exam_bank")}
        </Translation>
      ),
      path: "/exam-bank/add-exam",
      exact: true,
      component: React.lazy(() =>
        import("./examBank/AddExamBank/AddExamBankPage")
      ),
    },
    {
      title: (
        <Translation>
          {(t) => t("navigation.main.question_management")}
        </Translation>
      ),
      path: "/exam-bank/:examID",
      exact: true,
      component: React.lazy(() =>
        import("./examBank/ExamBankQuestions/ExamBankQuestionsPage")
      ),
    },
    {
      title: (
        <Translation>{(t) => t("navigation.main.question_bank")}</Translation>
      ),
      path: "/question-bank",
      exact: true,
      component: React.lazy(() =>
        import("./questionBank/QuestionBankQuestions/QuestionBankQuestionsPage")
      ),
    },
  ],
};
